<template lang="pug">
//- div(:class="currentView == 'chart' ? '': 'chartWrapper'")
.chartWrapper
    Button.cardBtn.textBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'textBtn' && withRawBtn") {{ toggleViewHint }}
    Button.iconBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'iconBtn' && withRawBtn" :icon="toggleViewHint")
    template(v-if="withCard")
        template(v-if="currentView == 'chart'")
            Card.card-shadow
                template(v-if="direction == 'vertical'")
                    bar-chart(
                        :chart-data="chartData.datacollection"
                        :options="chartData.options"
                        :width="chartWidth"
                        :height="chartHeight")
                template(v-else)
                    horizontal-bar-chart(
                        :chart-data="chartData.datacollection"
                        :options="chartData.options"
                        :width="chartWidth"
                        :height="chartHeight")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData")

    template(v-else)
        template(v-if="currentView == 'chart'")
            template(v-if="direction == 'vertical'")
                bar-chart(
                    :chart-data="chartData.datacollection"
                    :options="chartData.options"
                    :width="chartWidth"
                    :height="chartHeight")
            template(v-else)
                horizontal-bar-chart(
                    :chart-data="chartData.datacollection"
                    :options="chartData.options"
                    :width="chartWidth"
                    :height="chartHeight")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData" :no-data-text="$t('main.tableNoDataText')")

    Spin(size="large" fix v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";

import BarChart from "@/components/barChart.js";
import HorizontalBarChart from "@/components/horizontalBarChart.js";
import { getEdgeChartData } from "@/api/monitor.js";
import numeral from "numeral";

export default {
    name: "BarChartWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "" },
        titleDisplay: { type: Boolean, default: true },
        chartDataSetLabel: { type: Array, default: () => [] },
        chartDataSetLabelTranslate: { type: Boolean, default: true },
        numeralFormat: { type: String, default: "0.00a" },
        numeralFormatTooltips: { type: String, default: "" },
        numeralFormatYAxes: { type: String, default: "" },
        numeralFormatXAxes: { type: String, default: "" },
        topNSize: { type: Number, default: 5 },

        groupNames: { type: Array, default: () => [] },
        tags: { type: Array, default: () => [] },
        serviceGroupNames: { type: Array, default: () => [] },
        domains: { type: Array, default: () => [] },
        appProfileNames: { type: Array, default: () => [] },
        origins: { type: Array, default: () => [] },
        originHosts: { type: Array, default: () => [] },
        originPorts: { type: Array, default: () => [] },
        latencyStatusNames: { type: Array, default: () => [] },
        edgeNames: { type: Array, default: () => [] },
        slbNames: { type: Array, default: () => [] },
        netflowIps: { type: Array, default: () => [] },
        dateRange: { type: String, default: "" },
        customTimeRange: { type: Array, default: () => [] },

        withCard: { type: Boolean, default: true },
        withPropRawBtn: {},
        chartWidth: { type: Number, default: 600 },
        chartHeight: { type: Number, default: 340 },
        direction: { type: String, default: "vertical" },
        xAxesDisplay: { type: Boolean, default: true },
        yAxesDisplay: { type: Boolean, default: true },
        xAxesGridlineDisplay: { type: Boolean, default: true },
        yAxesGridlineDisplay: { type: Boolean, default: true },
        legendDisplay: { type: Boolean, default: true },

        // border, 背景色, 漸層背景色
        barBorderColors: { type: Array, default: () => [] },
        barBackgroundColors: { type: Array, default: () => [] },
        barBackgroundGradientStops: { type: Array, default: () => [] },

        // 是否使用後台dataset label, 無固定數組時使用
        // 如不使用則引用前台定義的chartDataSetLabel
        useBackendDatasetLabel: { type: Boolean, default: false },
        isPointStyle: { type: Boolean, default: false },
        apiEndpoint: { type: String, default: "" },
    },
    components: { BarChart, HorizontalBarChart },
    watch: {
        "$store.state.userPref.lang": function (newVal, oldVal) {
            this.fillChartData(this.nginxData);
        },
    },
    created() {},
    beforeDestroy() {
        bus.$off("searchChartData", this.getDataAndDraw);
    },
    data() {
        return {
            spinShow: false,
            chartData: {
                datacollection: {},
                options: {},
            },
            // topNSize: this.topNSize,
            nginxData: null,
            rawDataTableColumns: [],
            rawDataTableData: [],
            currentView: "chart",
        };
    },
    methods: {
        fillChartData(nginxData) {
            var self = this;
            var scales =
                this.direction == "vertical"
                    ? {
                          xAxes: [
                              {
                                  display: this.xAxesDisplay,
                                  ticks: {
                                      // callback: function (num, index, values) {
                                      //     return numeral(num).format(self.numeralFormat);
                                      // },
                                      beginAtZero: true,
                                  },
                                  gridLines: {
                                      display: false,
                                  },
                              },
                          ],
                          yAxes: [
                              {
                                  display: this.yAxesDisplay,
                                  ticks: {
                                      callback: function (num, index, values) {
                                          return numeral(num).format(
                                              self.numeralFormatYAxes ? self.numeralFormatYAxes : self.numeralFormat
                                          );
                                      },
                                      beginAtZero: true,
                                      maxTicksLimit: 6,
                                  },
                                  gridLines: {
                                      display: true,
                                      color: "#f0f0f0",
                                  },
                                  min: 0,
                              },
                          ],
                      }
                    : {
                          yAxes: [
                              {
                                  display: this.yAxesDisplay,
                                  ticks: {
                                      // callback: function (num, index, values) {
                                      //     return numeral(num).format(self.numeralFormat);
                                      // },
                                      beginAtZero: true,
                                  },
                                  gridLines: {
                                      display: false,
                                  },
                              },
                          ],
                          xAxes: [
                              {
                                  display: this.xAxesDisplay,
                                  ticks: {
                                      callback: function (num, index, values) {
                                          return numeral(num).format(
                                              self.numeralFormatXAxes ? self.numeralFormatXAxes : self.numeralFormat
                                          );
                                      },
                                      beginAtZero: true,
                                      maxTicksLimit: 6,
                                  },
                                  gridLines: {
                                      display: true,
                                      color: "#f0f0f0",
                                  },
                                  min: 0,
                              },
                          ],
                      };
            var datasets = nginxData.data.datasets.map((dataset, index) => {
                return {
                    label: this.useBackendDatasetLabel
                        ? dataset.label
                        : this.chartDataSetLabelTranslate
                        ? `Top${this.topNSize} ${this.$i18n.t(this.chartDataSetLabel[index])}`
                        : `Top${this.topNSize} ${this.chartDataSetLabel[index]}`,
                    // label: "",
                    data: dataset.data,
                    barPercentage: 0.3,
                    pointRadius: 0,
                    pointHoverRadius: 2,
                    backgroundColor: this.barBackgroundColors[index],
                    borderColor: this.barBorderColors[index],
                    borderWidth: 1,
                    fill: true,
                };
            });

            let legendLabel = {};
            if (this.isPointStyle == true) {
                legendLabel = {
                    usePointStyle: true,
                    boxWidth: 8,
                };
            }

            var chartData = {
                datacollection: {
                    labels: nginxData.data.labels,
                    datasets: datasets,
                },
                options: {
                    legend: {
                        display: this.legendDisplay,
                        onClick: null,
                        labels: legendLabel,
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        mode: "single",
                        callbacks: {
                            label: function (tooltipItems, data) {
                                let numeralFormat = self.numeralFormatTooltip
                                    ? self.numeralFormatTooltip
                                    : self.numeralFormat;

                                return `${
                                    self.direction == "vertical"
                                        ? numeral(tooltipItems.yLabel).format(numeralFormat)
                                        : numeral(tooltipItems.xLabel).format(self.numeralFormat)
                                }`;
                            },
                        },
                    },
                    scales: scales,
                    title: {
                        display: this.titleDisplay,
                        text: this.chartTitle,
                    },
                },
            };

            this.chartData = chartData;
        },
        getNginxData() {
            this.spinShow = true;
            var chartOptions = {
                chartType: this.chartType,
                groupNames: this.queryFilter.groupNames,
                tags: this.queryFilter.tags,
                serviceGroupNames: this.queryFilter.serviceGroupNames,
                domains: this.queryFilter.domains,
                appProfileNames: this.queryFilter.appProfileNames,
                origins: this.queryFilter.origins,
                originHosts: this.queryFilter.originHosts,
                originPorts: this.queryFilter.originPorts,
                slbNames: this.queryFilter.slbNames,
                edgeNames: this.queryFilter.edgeNames,
                netflowIps: this.queryFilter.netflowIps,
                latencyStatusNames: this.queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.queryFilter.dateRangeOptions.index,
                    customTimeRange: this.queryFilter.dateRangeOptions.customTimeRange,
                },
                topNSize: this.topNSize,
                apiEndpoint: this.apiEndpoint,
            };

            return getEdgeChartData(chartOptions);
        },
        getDataAndDraw() {
            this.getNginxData().then((nginxData) => {
                this.nginxData = nginxData;
                this.fillChartData(nginxData);
                this.spinShow = false;
            });
        },
        toggleCurrentView() {
            if (this.currentView == "chart") {
                this.currentView = "rawDataTable";
                this.rawDataTableColumns = [
                    {
                        title: this.chartTitle
                            ? this.$i18n.t(this.chartTitle)
                            : this.$i18n.t(this.chartDataSetLabel[0]),
                        key: "title",
                    },
                    {
                        title: "Value",
                        key: "value",
                    },
                ];
                let dataCollection = this.chartData.datacollection;
                this.rawDataTableData = dataCollection.labels.map((label, i) => {
                    return {
                        title: label,
                        value: numeral(dataCollection.datasets[0].data[i]).format(this.numeralFormat),
                    };
                });
            } else {
                this.currentView = "chart";
            }
        },
    },
    mounted() {
        this.getDataAndDraw();
        bus.$on("searchChartData", this.getDataAndDraw);
    },
    computed: {
        chartStyle() {
            return { height: "100%", width: this.chartWidth + "px" };
        },
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
        withRawBtn() {
            // no button for chart in NetflowAnalyze.vue
            if (this.apiEndpoint == "/monitor/netflowchartdata") {
                return false;
            }

            return this.withPropRawBtn !== undefined
                ? this.withPropRawBtn
                : this.$store.getters.getChartConfig.withRawBtn;
        },
        toggleViewHint() {
            if (this.showRawBtnStyle == "textBtn") return this.currentView == "chart" ? "View Raw" : "Back To Chart";
            return this.currentView == "chart" ? "md-eye" : "md-redo";
        },
        // query 參數, 優先使用props, 否則去看store
        queryFilter() {
            var queryFilter = this.$store.state.dashboard.queryFilter;

            // 如果dashboardQueryFilter組件還沒生成, 那就先看store > queryGroupName
            var queryGroupName = this.$store.state.queryGroupName;
            return {
                groupNames:
                    this.groupNames.length > 0
                        ? this.groupNames
                        : queryGroupName !== "all"
                        ? [queryGroupName]
                        : queryFilter.groupNames,
                tags: this.tags.length > 0 ? this.tags : queryFilter.tags,
                serviceGroupNames:
                    this.serviceGroupNames.length > 0 ? this.serviceGroupNames : queryFilter.serviceGroupNames,
                domains: this.domains.length > 0 ? this.domains : queryFilter.serverNames,
                appProfileNames: this.appProfileNames.length > 0 ? this.appProfileNames : queryFilter.appProfileNames,
                origins: this.origins.length > 0 ? this.origins : queryFilter.origins,
                originHosts: this.originHosts.length > 0 ? this.originHosts : queryFilter.originHosts,
                originPorts: this.originPorts.length > 0 ? this.originPorts : queryFilter.originPorts,
                slbNames: this.slbNames.length > 0 ? this.slbNames : queryFilter.slbNames,
                edgeNames: this.edgeNames.length > 0 ? this.edgeNames : queryFilter.edgeNames,
                netflowIps: this.netflowIps.length > 0 ? this.netflowIps : queryFilter.netflowIps,
                latencyStatusNames:
                    this.latencyStatusNames.length > 0 ? this.latencyStatusNames : queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.dateRange || queryFilter.dateRangeOptions.index,
                    customTimeRange:
                        this.customTimeRange.length > 0
                            ? customTimeRange
                            : queryFilter.dateRangeOptions.customTimeRange,
                },
            };
        },
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/BarChartWrapper.vue